import { SolvdHome } from '../custom-homes/solvd';
import { useEffect } from 'react';
import { burl } from '@/services/urls';
import axios from 'axios';
// import { NewDeliveryManHome } from '../custom-homes/new-delivery-man';
import { PublicHome } from '../public-site/PublicHome';
// import { createWorker } from "tesseract.js";

export const Home = () => {
	console.log('hello');
	useEffect(() => {
		// bridge();
		// cancelBridge();
	}, []);

	const bridge = async args => {
		// const to = 'titansoft'

		// const apiKey = '02a63770-d905-4497-a406-d4b12c035b11'; // titansoft
		const apiKey = '474d2485-7dbb-4cb3-8f5d-24ac03d91cb7'; // papaxristos
		// const apiKey = '12a63170-d905-5009-c406-d4b12c035io'; // inorder
		// const apiKey = '';
		// console.log("getDeliveryClocks", args);
		let data = {};
		console.log('aaaaaaaaaaaaaaa');
		try {
			// const url = burl + `/bridge/titansoft/new-order`;
			const url = burl + `/bridge/external/new-order`;

			console.log(url);

			const res = await axios.post(
				url,

				// LATEST:
				{
					apiKey,
					// shopId: 93,
					// platform: 'efood',
					card: true,
					tip: 0,
					total: 19.9,
					time: 30,
					name: 'Pelatis Test',
					phone: '+306900000000',
					address: 'Ermou 1',
					area: 'Syntagma',
					city: 'Athens',
					orderComments: 'min kriosei to pagoto',
					addressComments: 'piso piso deksia',
					floor: 2,
					doorbell: 'papadopoulos',
					lat: 37.9755,
					lng: 23.7348,

					// platformOrderId: 'TEST-X-002',

					// platformFriendlyId: '#61',
				},
				// kastoria
				// {
				// 	apiKey: '02a63770-d905-4497-a406-d4b12c035b11',
				// 	order_id: 'TEST-TS-002',
				// 	shopId: 93,
				// 	platform: 'efood',
				// 	card: true,
				// 	tip: 0,
				// 	total: 18.5,
				// 	time: 30,
				// 	name: 'TitanSoft Test',
				// 	phone: '+306900000000',
				// 	address: 'Ermou 1',
				// 	area: 'Syntagma',
				// 	city: 'Athens',
				// 	platformDeliveryId: '#61',
				// 	orderComments: 'TEST ORDER - TitanSoft sandbox, please ignore',
				// 	addressComments: 'piso piso deksia',
				// 	floor: 2,
				// 	doorbell: 'papadopoulos',
				// 	lat: 37.9755,
				// 	lng: 23.7348,
				// },

				// athina
				{
					// apiKey: '02a63770-d905-4497-a406-d4b12c035b11',
					order_id: 'TEST-TS-002-333333',
					shopId: 297,
					platform: 'efood',
					card: true,
					tip: 0,
					total: 18.5,
					time: 30,
					name: 'TitanSoft Test',
					phone: '+306900000000',
					address: 'Παπαφλέσα 41',
					area: 'Syntagma',
					city: 'Athens',
					platformDeliveryId: '#62',
					orderComments: 'TEST ORDER - TitanSoft sandbox, please ignore',
					addressComments: 'piso piso deksia',
					floor: 2,
					doorbell: 'papadopoulos',
					lat: 38.0515096,
					lng: 23.8109624,

					//  street: "Παπαφλέσα 41",
					//   city: "Αθήνα", // apo city.name
					//   lat: 38.0515096,
					//   lon: 23.8109624,
				},

				// 	 {
				// 	// arr: [1, 2],
				// 	// obj: { hi: 1, bye: { aa: "str" } },
				// 	// dada: "strrrr",
				// 	apiKey: '02a63770-d905-4497-a406-d4b12c035b68',
				// 	shopid: '8-48',
				// 	orderid: '101',
				// 	customername: 'testname testname',
				// 	customeraddress: 'test address, 14122, poli',
				// 	customerphone: '1234567899',
				// 	customercomment: 'sxoliasxoliasxolia',
				// 	odos: 'odostest',
				// 	poli: 'politest',
				// 	price: '12',
				// 	timetoReady: '0',
				// }
				// {
				// 	apiKey: '02a63770-d905-4497-a406-d4b12c035b11',
				// 	// shopid: '16-291',
				// 	shopid: '8-48',

				// 	orderid: '101',
				// 	customername: 'testname testname',
				// 	customeraddress: 'Συνταγματάρχου δαβάκη 12, 14451, Μεταμορφωση',
				// 	customerphone: '1234567899',
				// 	customercomment: 'test',
				// 	odos: 'odostest',
				// 	poli: 'politest',
				// 	price: '12',
				// 	timetoReady: '0',
				// },
			);

			console.log('orderz', res);
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			...data,
		};
	};

	// const cancelBridge = async args => {
	// 	// console.log("getDeliveryClocks", args);
	// 	let data = {};
	// 	console.log('aaaaaaaaaaaaaaa');
	// 	try {
	// 		const url = burl + `/bridge/poseidon/cancel-order/`;

	// 		console.log(url);

	// 		const res = await axios.post(url, {
	// 			// arr: [1, 2],
	// 			// obj: { hi: 1, bye: { aa: "str" } },
	// 			// dada: "strrrr",
	// 			apiKey: '02a63770-d905-4497-a406-d4b12c035b68',
	// 			orderid: '397951',
	// 		});

	// 		console.log('orderz', res);
	// 		data = res?.data;
	// 	} catch (error) {
	// 		console.log(error);
	// 		return {
	// 			error: true,
	// 		};
	// 	}

	// 	return {
	// 		...data,
	// 	};
	// };

	if (typeof window?.location?.href === 'string' && window.location.href?.includes?.('solvd')) {
		return <SolvdHome />;
	}

	// return <NewDeliveryManHome />;
	return <PublicHome />;
};

// function Home() {
//   const [ocr, setOcr] = useState("");
//   const [imageData, setImageData] = useState(null);
//   const [worker, setWorker] = useState(null)

//   useEffect(() => {
//     initWorker()

//   }, [])

//   const initWorker = async () => {
//     const worker = await createWorker({
//       logger: (m) => {
//         console.log(m);
//       },
//     });
//     setWorker(worker)
//   }
//   const convertImageToText = async () => {
//     if (!imageData) return;
//     await worker.load();
//     await worker.loadLanguage(['eng', 'ell']);
//     await worker.initialize(['eng', 'ell']);
//     const {
//       data: { text },
//     } = await worker.recognize(imageData);
//     setOcr(text);
//   };

//   useEffect(() => {
//     convertImageToText();
//   }, [imageData]);

//   function handleImageChange(e) {
//     const file = e.target.files[0];
//     if(!file)return;
//     const reader = new FileReader();
//     reader.onloadend = () => {
//       const imageDataUri = reader.result;
//       console.log({ imageDataUri });
//       setImageData(imageDataUri);
//     };
//     reader.readAsDataURL(file);
//   }
//   return (
//     <div className="App">
//       <div>
//         <p>Choose an Image</p>
//         <input
//           type="file"
//           name=""
//           id=""
//           onChange={handleImageChange}
//           accept="image/*"
//         />
//       </div>
//       <div className="display-flex">
//         <img src={imageData} alt="" srcset="" />
//         <p>{ocr}</p>
//       </div>
//     </div>
//   );
// }
